export class WorkSpaceUserPermissions {
  private readonly _permissions: string[];

  constructor(props: { permissions: string[] }) {
    this._permissions = props.permissions;
  }

  get permissions(): string[] {
    return this._permissions;
  }
}
